import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import history from 'app/routes/history';
import SectionGroup from 'app/components/general/SectionGroup';
import Button from 'app/components/general/Button';
import Dropzone from 'react-dropzone';
import Isvg from 'react-inlinesvg';

import UploadIcon from 'app/images/icons/upload.svg';


interface IUploadFileProps {
  appReady: boolean;
  actions: any;
  match: any;
  organisations: any;
  competitions: any;
  errors: any;
  changeFileContent: any;
}

interface IUploadFileState {
  dragStatus: any;
}
export default class UploadFile extends React.Component<
  IUploadFileProps,
  IUploadFileState
> {
  static defaultProps: IUploadFileProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    organisations: {},
    competitions: {},
    errors: undefined,
    changeFileContent: undefined,
  };

  state: IUploadFileState = {
    dragStatus: null,
  };

  handleFileUpload = (acceptedFiles) => {
    const reader = new FileReader();

    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = () => {
      this.props.changeFileContent(reader.result);
    };
    acceptedFiles.forEach((file) => reader.readAsText(file));
  };

  render(): React.ReactNode {
    const getDropStatus = () => {
      if (this.state.dragStatus === 'accepted') {
        return 'accept';
      }
      if (this.state.dragStatus === 'error') {
        return 'error';
      }
      return null;
    };
    return (
      <SectionGroup
        title="Upload CSV file"
      >
        <div className="row">
          <div className="col">
            <Dropzone
              accept=".csv"
              onDrop={(acceptedFiles) => this.handleFileUpload(acceptedFiles)}
              onDropAccepted={() => this.setState({
                dragStatus: 'accepted',
              })}
              onDropRejected={() => this.setState({
                dragStatus: 'error',
              })}
            >
              {({ getRootProps, getInputProps, acceptedFiles }) => {
                let content = (
                  <div className="upload-prompt">
                    <Isvg className="upload-icon" src={UploadIcon} />
                    <span className="d-inline-block with-margin-left">Drag and drop your CSV file here</span>
                  </div>
                );
                if (!_.isEmpty(acceptedFiles)) {
                  const files = acceptedFiles.map((file) => (
                    <li className="file-list" key="dropzone-list">
                      {file.name}
                      {' '}
                      -
                      {' '}
                      <span key="dropzone-span">
                        {file.size}
                        {' '}
                        bytes
                      </span>
                    </li>
                  ));

                  content = [
                    <div className="drop-title" key="dropzone-title">
                      Uploaded file:
                    </div>,
                    files,
                  ];
                }
                return (
                  <section key="dropzone-p" className={getDropStatus()}>
                    <div
                      key="dropzone"
                      {...getRootProps({
                        className: 'dropzone',
                      })}
                    >
                      <input {...getInputProps()} key="dropzone-input" />
                      {content}
                    </div>
                  </section>
                );
              }}
            </Dropzone>
            <div
              className={classnames('row with-margin-top', {
                'd-none': this.state.dragStatus !== 'accepted',
              })}
            >
              <div className="col btn-flex-group less-padding">
                <div className="btn-flex-container">
                  <Button
                    className="btn-standard btn-1"
                    type="submit"
                    onClick={() => history.push(
                      `/connections/${this.props.match.params.connectionId}/run/csv/fixture/map`,
                    )}
                  >
                    Map Fields
                  </Button>
                  <Button
                    onClick={() => history.push('/connections')}
                    className="btn-standard btn-2"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionGroup>
    );
  }
}
